/* assets/adore-hp.js
   29 Sep 2026, CRO build 4. Behaviour for the new home page (sections/adore-hp-*.liquid).
   Every home section loads this file; the guard below makes it run once.
   1. Motion: adds "in" to .hp-wipe photos (by watching their parent) and .hp-sweep buttons the first time they scroll into view (once only).
      Nothing is hidden if the script fails or the device asks for reduced motion (the hp-mo class is never added).
   2. "Shop rugs by" tabs: click, arrow keys, Home and End. Hidden panels stay in the page (hidden visually only).
   3. Before and after slider.
   4. Reviews row: flooring, rug, flooring first, the rest shuffled; customer photo cards slotted in between.
   5. Phone button bar: shows once the hero has scrolled away, and lifts the Podium "Text us" pill above it. */
(function () {
  if (window.adoreHPLoaded) return;
  window.adoreHPLoaded = true;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    root.classList.add('hp-mo');
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target;
        if (t.classList.contains('hp-sweep')) t.classList.add('in');
        else [].forEach.call(t.children, function (c) { if (c.classList.contains('hp-wipe')) c.classList.add('in'); });
        io.unobserve(t);
      });
    }, { threshold: 0.2 });
  }

  function each(scope, sel, fn) { [].forEach.call(scope.querySelectorAll(sel), fn); }

  function init(scope) {
    scope = scope || document;

    // 1. motion
    // a clipped photo has no visible area, so Chrome never reports it as on screen: watch its parent instead
    if (io) each(scope, '.hp-wipe:not([data-hpo]),.hp-sweep:not([data-hpo])', function (n) {
      n.setAttribute('data-hpo', '');
      io.observe(n.classList.contains('hp-wipe') ? n.parentElement : n);
    });
    // 3 Oct 2026 (panel re-audit): safety net. If the reveal never fires (an observer that does not report, a browser
    // that pauses it), every wiped photo and swept button shows itself after 4 seconds anyway.
    setTimeout(function () { each(document, '.hp-wipe,.hp-sweep', function (n) { n.classList.add('in'); }); }, 4000);

    // 2. tabs
    each(scope, '[data-hp-tabs]:not([data-hpi])', function (box) {
      box.setAttribute('data-hpi', '');
      var list = box.querySelector('[role=tablist]');
      var tabs = [].slice.call(box.querySelectorAll('[role=tab]'));
      function pick(t, focus) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) { p.classList.toggle('on', on); p.setAttribute('aria-hidden', on ? 'false' : 'true'); }
        });
        if (focus) t.focus({ preventScroll: true });
        // keep the chosen pill in view on phones without scrolling the page
        if (list && list.scrollWidth > list.clientWidth) {
          var l = t.offsetLeft - 16, r = t.offsetLeft + t.offsetWidth + 16 - list.clientWidth;
          if (list.scrollLeft > l) list.scrollTo({ left: l, behavior: reduce ? 'auto' : 'smooth' });
          else if (list.scrollLeft < r) list.scrollTo({ left: r, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { pick(t); });
        t.addEventListener('keydown', function (e) {
          var j;
          if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') j = 0;
          else if (e.key === 'End') j = tabs.length - 1;
          else return;
          e.preventDefault();
          pick(tabs[j], true);
        });
      });
    });

    // 2b. desktop arrows on sideways rows (mouse users cannot swipe)
    each(scope, '.hp-row[data-hp-arrows]:not([data-hpa])', function (row) {
      row.setAttribute('data-hpa', '');
      var wrap = document.createElement('div');
      wrap.className = 'hp-rowwrap';
      row.parentNode.insertBefore(wrap, row);
      wrap.appendChild(row);
      var svg = function (d) { return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
      var prev = document.createElement('button'), next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.className = 'hp-arr hp-arr--p'; next.className = 'hp-arr hp-arr--n';
      prev.setAttribute('aria-label', 'Scroll back'); next.setAttribute('aria-label', 'Scroll forward');
      prev.innerHTML = svg('M15 6l-6 6 6 6'); next.innerHTML = svg('M9 6l6 6-6 6');
      wrap.appendChild(prev); wrap.appendChild(next);
      function step(dir) { row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); }
      function state() { prev.disabled = row.scrollLeft < 4; next.disabled = row.scrollLeft + row.clientWidth > row.scrollWidth - 4; }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', state, { passive: true });
      window.addEventListener('resize', state);
      state();
    });

    // 3. before and after
    each(scope, '[data-hp-ba]:not([data-hpi])', function (b) {
      b.setAttribute('data-hpi', '');
      var r = b.querySelector('input[type=range]');
      function set() { b.style.setProperty('--pos', r.value + '%'); }
      r.addEventListener('input', set);
      r.addEventListener('change', set);
      set();
    });

    // 4. reviews order
    each(scope, '[data-hp-reviews]:not([data-hpi])', function (row) {
      row.setAttribute('data-hpi', '');
      var cards = [].slice.call(row.querySelectorAll('.hp-rv__card'));
      var photos = [].slice.call(row.querySelectorAll('.hp-rv__photo'));
      var end = row.querySelector('.hp-rv__all');
      function take(list, test) { for (var i = 0; i < list.length; i++) { if (test(list[i])) return list.splice(i, 1)[0]; } return null; }
      var pool = cards.slice(), first = [];
      // 13 Oct 2026 (owner approved): cards marked data-pin (1 to 4, set in sections/adore-hp-reviews.liquid) go first, in pin order:
      // fast arrival, right size, colour as pictured, installer quality. Then the flooring, rug, flooring rule, then the rest shuffled.
      [1, 2, 3, 4].forEach(function (n) { var c = take(pool, function (x) { return x.dataset.pin === String(n); }); if (c) first.push(c); });
      var f1 = take(pool, function (c) { return c.dataset.kind === 'floor'; });
      var r1 = take(pool, function (c) { return c.dataset.kind === 'rug' && c.dataset.verified; }) || take(pool, function (c) { return c.dataset.kind === 'rug'; });
      var f2 = take(pool, function (c) { return c.dataset.kind === 'floor'; });
      [f1, r1, f2].forEach(function (c) { if (c) first.push(c); });
      for (var i = pool.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = pool[i]; pool[i] = pool[j]; pool[j] = t; }
      var order = first.concat(pool), max = parseInt(row.getAttribute('data-max') || '10', 10), out = [];
      order.forEach(function (c, k) {
        if (k >= max) { c.remove(); return; }
        out.push(c);
        if (k % 2 === 0 && photos.length) out.push(photos.shift()); // a customer photo after every second review
      });
      out = out.concat(photos);
      out.forEach(function (c) { row.insertBefore(c, end); });
    });
  }

  // 5. phone button bar
  function bar() {
    var hero = document.querySelector('[data-hp-hero]'), b = document.querySelector('[data-hp-bar]');
    if (!hero || !b || !('IntersectionObserver' in window) || b.hasAttribute('data-hpi')) return;
    b.setAttribute('data-hpi', '');
    new IntersectionObserver(function (es) {
      var e = es[es.length - 1];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      b.classList.toggle('show', show);
      root.classList.toggle('hp-bar-up', show);
    }, { threshold: 0 }).observe(hero);
    // 5 Oct 2026 (Nas: buttons too clustered): the bar steps aside while a row of rug cards is on screen, so it never
    // stacks under the cards. The rows are the "Shop rugs by" and Pierre Cardin rows.
    var rows = document.querySelectorAll('.hp-rugs .hp-row:not(.hp-tabs), .hp-pc .hp-row'), onScreen = 0;
    if (rows.length) {
      var hold = new IntersectionObserver(function (es) {
        es.forEach(function (x) {
          if (x.isIntersecting && !x.target.__hpIn) { x.target.__hpIn = 1; onScreen++; }
          else if (!x.isIntersecting && x.target.__hpIn) { x.target.__hpIn = 0; onScreen--; }
        });
        root.classList.toggle('hp-bar-hold', onScreen > 0);
      }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
      [].forEach.call(rows, function (r) { hold.observe(r); });
    }
  }

  function start() { init(document); bar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); bar(); });
})();
